import { useIFrameContext } from './IFrameContext';
import { isSSR } from './utils';

const MOBILE_SCREEN_WIDTH = 700;

export function useIsMobileView(
  params: { customMobileScreenWidth?: number[]; wrapCustomMatch?: boolean } = {
    customMobileScreenWidth: [],
    wrapCustomMatch: false
  }
): any {
  const isIFrame = useIFrameContext();
  if (isSSR()) {
    return Boolean(isIFrame);
  }

  const customMobileScreenWidth = params?.customMobileScreenWidth || [];
  if (customMobileScreenWidth.length > 0) {
    let mobileScreenDimension;
    let isMobileView;
    for (let i = 0; i < customMobileScreenWidth.length; i++) {
      mobileScreenDimension = customMobileScreenWidth[i];
      isMobileView =
        (typeof window.visualViewport !== 'undefined'
          ? window.visualViewport.width
          : window.screen.availWidth) <= mobileScreenDimension;
      if (isMobileView) {
        if (params?.wrapCustomMatch) {
          return { isMobileView: true };
        }
        return true;
      }
    }
  }

  const isMobile =
    (typeof window.visualViewport !== 'undefined'
      ? window.visualViewport.width
      : window.screen.availWidth) <= MOBILE_SCREEN_WIDTH;
  return isIFrame || isMobile;
}
